export const DocumentosFaltantes=[
    {
        Header: "No. de Guía",
        accessor: "guiahija"
        
      },
      {
        accessor: "descprod",
        Header: "Descripcion"
      },
      {
        accessor: "Location",
        Header: "Estatus"
      },
      {
        accessor: "valfob",
        Header: "Valor"
      }
]

export const DocumentoInicial={
  guiahija:"-",
  descprod:"-",
  Location:"-",
  valfob:"-",
  }